import { render, staticRenderFns } from "./PageDocCommandesAide.vue?vue&type=template&id=58345838&"
import script from "./PageDocCommandesAide.vue?vue&type=script&lang=js&"
export * from "./PageDocCommandesAide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports